import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { FormField } from '@/App/tiles/ForwardAccumulator/parts/RightPanel/common/FormField.tsx';
import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import {
  selectForwardAccumulatorCustomFields,
  selectForwardAccumulatorSettlementFrequencyData,
} from '@/store/forwardAccumulator/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';
import type { Frequency } from '@/types/common';

const SettlementFrequency = ({ useShortLabel = false }: { useShortLabel?: boolean }) => {
  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const { settlementFrequency, settlementFrequencyList, numberOfSettlements } = useAppSelector((state) =>
    selectForwardAccumulatorSettlementFrequencyData(state, tileId),
  );

  const handleFixingFrequencies = (event: React.ChangeEvent<HTMLSelectElement>) => {
    sgwtWebAnalytics?.trackEvent('Forward Accumulator', 'Settlement frequency changed', event.target.value);

    check({
      settlementFrequency: event.target.value as Frequency,
    });
  };

  const isCustom = useAppSelector(
    (state) => selectForwardAccumulatorCustomFields(state, tileId)?.includes('SettlementFrequency') ?? false,
  );

  return (
    <FormField formattedMessageId={`forwardAccumulator.form.settlementFrequencies${useShortLabel ? '.short' : ''}`}>
      <div data-e2e="settlement-frequency-text" className={`${isCustom ? 'text-info' : ''} `}>
        <Form.Select
          value={settlementFrequency}
          onChange={handleFixingFrequencies}
          size="sm"
          data-e2e="settlement-frequencies-selector"
        >
          {settlementFrequencyList?.map((mode) => (
            <option key={mode} value={mode}>
              <FormattedMessage id={`forwardAccumulator.form.fixingFrequencies.${mode}`} />
              {isDefined(numberOfSettlements) && mode === settlementFrequency ? ` (${numberOfSettlements})` : ''}
            </option>
          ))}
        </Form.Select>
      </div>
    </FormField>
  );
};

export default SettlementFrequency;
